import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

/**
 * Renders profile image when available; falls back to initials text.
 */
const AccountAvatarFace = ({ imageUrl, initials, alt = '' }) => {
    const [imageError, setImageError] = useState(false);

    useEffect(() => {
        setImageError(false);
    }, [imageUrl]);

    if (imageUrl && !imageError) {
        return (
            <img
                src={imageUrl}
                alt={alt}
                onError={() => setImageError(true)}
                style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
            />
        );
    }

    return initials;
};

AccountAvatarFace.propTypes = {
    imageUrl: PropTypes.string,
    initials: PropTypes.node.isRequired,
    alt: PropTypes.string,
};

export default AccountAvatarFace;
